const $ = require('jquery');

$(document).ready(function() {

  // Function to set the Top CSS property value for the Slick Previous and Next SVG icons.
  function setCssTopValue() {
    let $slickImgHeight = $('.pest-slide--image img').height();
    let $slickIconHeight = $('.slick-prev').height();
    let $cssTopValue = ($slickImgHeight / 2) - ($slickIconHeight / 2);
    $('.slick-prev, .slick-next').css('top', $cssTopValue);
  }

  // Quick test to see if there is a .slick-slider instance before running any functions.
  if ($('.pest-slider').length) {

    // Init the Slick Slider element when page is ready.
    $('.pest-slider').slick({
      dots: true,
      infinite: true
    });

    // Run the function initially.
    setCssTopValue();

    // Rerun the function on page resize.
    window.addEventListener('resize', setCssTopValue, {
      passive: true,
    });
  }

});
